import "./src/css/index.css"

import { Buffer } from "buffer"
window.Buffer = Buffer